import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export type Brand = {
    id: string;
    title: string;
    value: string;
};

@Injectable()
export class BrandRepository extends RestfulService {
    constructor(public override httpClient: HttpClient, public override router: Router) {
        super(httpClient, router);
    }
    find(page = 1, pageSize = 150): Observable<Brand[]> {
        return this.doGet(`parametre/nomtable/BRAND`).pipe(
            map((res) =>
                res.map((brand: any) => ({
                    id: brand.id,
                    title: brand.mapLocalLibelle,
                    value: brand.valeur,
                }))
            )
        );
    }
}
